import styled from "styled-components";

export const Container = styled.div`
  border-bottom: 1px solid #d1d1d1;
  padding: 30px 0px 20px;
`;
export const CommonHeader = styled.h4`
  font-size: 16px;
  text-transform: none;
  color: #172839;
  font-weight: 500;
  margin: 0;
`;
export const LocationFrom = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 20px 0px;
`;
export const LocationFromName = styled.div`
  padding-right: 60px;
`;
export const LocationName = styled.div`
  font-size: 14px;
`;
export const LocationRoadName = styled.div`
  font-size: 12px;
`;
export const Time = styled.div`
  padding: 0px 20px 0px 10px;
  font-weight: 500;
`;
export const LocationTo = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 20px 0px;
`;
export const BorddingAndDroppingPoint = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
`;
